import ProjectsTemplateDesktop from "./projects-template-desktop";

export default ProjectsTemplateDesktop;